// Console filter to suppress specific hydration errors
// This helps clean up the console when there are minor whitespace hydration issues

const suppressHydrationErrors = () => {
  // Only suppress errors if environment variable is set to true
  const shouldSuppress = process.env.REACT_APP_SUPPRESS_HYDRATION_ERRORS === 'true';
  
  if (!shouldSuppress) {
    console.log('🔧 Hydration error suppression is disabled via environment variable');
    return;
  }

  console.log('🔇 Hydration error suppression is enabled');

  // Store original console methods
  const originalError = console.error;
  const originalWarn = console.warn;

  // Override console.error to filter hydration messages
  console.error = (...args) => {
    // Check if this is a hydration error we want to suppress
    if (args.length > 0 && typeof args[0] === 'string') {
      const message = args[0];
      
      // Suppress specific hydration error patterns
      const suppressPatterns = [
        'text nodes cannot be a child of',
        'This will cause a hydration error',
        'whitespace text nodes cannot be a child',
        'Make sure you don\'t have any extra whitespace',
        /In HTML, .* text nodes cannot be a child of/,
        /This will cause a hydration error/
      ];

      const shouldSuppress = suppressPatterns.some(pattern => {
        if (typeof pattern === 'string') {
          return message.includes(pattern);
        } else if (pattern instanceof RegExp) {
          return pattern.test(message);
        }
        return false;
      });

      if (shouldSuppress) {
        // Optionally log a simplified message instead
        // console.log('🔇 Hydration warning suppressed');
        return;
      }
    }

    // Allow all other errors to pass through
    originalError.apply(console, args);
  };

  // Override console.warn for hydration warnings
  console.warn = (...args) => {
    if (args.length > 0 && typeof args[0] === 'string') {
      const message = args[0];
      
      if (message.includes('hydration') || message.includes('Hydration')) {
        // Suppress hydration warnings
        return;
      }
    }

    // Allow all other warnings to pass through
    originalWarn.apply(console, args);
  };
};

// Function to restore original console methods if needed
const restoreConsole = () => {
  // This would require storing the original methods globally
  // For now, just refresh the page to restore
  console.log('To restore console, refresh the page');
};

export { suppressHydrationErrors, restoreConsole };
